export default [
    // {
    //     path: '/equipment_in_out',
    //     component : () => import('../../views/equipment_in_out/equipment_in_out.vue'),
    // },
    {
        path: '/equipment_io',
        component : () => import('../../views/equipment_in_out/equipment_io.vue'),
    },
];
